<template>
  <v-navigation-drawer
    v-model="show"
    class="elevation-5"
    disable-route-watcher
    fixed
    height="100vh"
    style="margin-top: 64px; z-index: 1"
  >
    <v-container class="px-2" fluid>
      <v-filters-sidebar-title />
      <v-filters-sidebar-like-pattern-brand />
      <v-filters-sidebar-like-pattern-category />
      <v-filters-sidebar-like-pattern-name />
      <v-filters-sidebar-not-like-pattern />
      <v-filters-sidebar-without-predictions />
      <v-filters-sidebar-best-prediction />
      <v-filters-sidebar-only-correct />
      <v-filters-sidebar-apply-button class="mt-3" />
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapMutations, mapState } = createNamespacedHelpers("classifier");

import VFiltersSidebarApplyButton from "./FiltersSidebarApplyButton";
import VFiltersSidebarBestPrediction from "./FiltersSidebarBestPrediction";
import VFiltersSidebarLikePatternBrand from "./FiltersSidebarLikePatternBrand";
import VFiltersSidebarLikePatternCategory from "./FiltersSidebarLikePatternCategory";
import VFiltersSidebarLikePatternName from "./FiltersSidebarLikePatternName";
import VFiltersSidebarNotLikePattern from "./FiltersSidebarNotLikePattern";
import VFiltersSidebarOnlyCorrect from "./FiltersSidebarOnlyCorrect";
import VFiltersSidebarTitle from "./FiltersSidebarTitle";
import VFiltersSidebarWithoutPredictions from "./FiltersSidebarWithoutPredictions";

export default {
  components: {
    VFiltersSidebarApplyButton,
    VFiltersSidebarBestPrediction,
    VFiltersSidebarLikePatternBrand,
    VFiltersSidebarLikePatternCategory,
    VFiltersSidebarLikePatternName,
    VFiltersSidebarNotLikePattern,
    VFiltersSidebarOnlyCorrect,
    VFiltersSidebarTitle,
    VFiltersSidebarWithoutPredictions,
  },
  computed: {
    ...mapState(["showFiltersSidebar"]),
    show: {
      get() {
        return this.showFiltersSidebar;
      },
      set(value) {
        this.setShowFiltersSidebar(value);
      },
    },
  },
  methods: {
    ...mapMutations(["clearFilters", "setShowFiltersSidebar"]),
    /**
     * Show or hide the component according to the route that the app is at.
     */
    updateShowAccordingToRoute() {
      this.show = this.$route.matched.some(({ name }) =>
        name.includes("classifier/predictions")
      );
    },
  },
  watch: {
    /**
     * Clear the filters when the route changes and manage the visibility of
     * the sidebar to close/open it according to the view that we are showing.
     */
    $route() {
      this.clearFilters();
      this.updateShowAccordingToRoute();
    },
  },
  created() {
    this.updateShowAccordingToRoute();
  },
};
</script>
